export default "__VITE_ASSET__D2c_7gAO__"